import React from 'react';
import { FunctionFactory } from 'survey-core';
import { ComfortLevel } from '../quiz/comfort';

const comfortSplashHtml = `
<div class="new-quote-container centered"> 
  <div class="splash-icon">{comfortSplashIcon}</div>
  <div class="splash-header">
    <h1>{comfortSplashTitle}</h1>
    <div class="quote">
      {comfortQuote}
    </div>
  </div>
</div>`;

const comfortSplashExpression = {
  name: "comfortQuote",
  expression: "renderComfortQuote({comfort})",
};

function renderComfortQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch(params[0] as ComfortLevel) {
    case ComfortLevel.Never:
      return `We’ll walk you through the basics and help you build confidence step-by-step.`;
    case ComfortLevel.Learning:
    case ComfortLevel.Reguarly:
      return `We’ll show you how to perfect your form, and introduce some variations that might be a better fit for your body.`;
    case ComfortLevel.CantDo:
      return `There’s no such thing as a “must do” exercise. We’ll help you find effective alternatives that work with your body.`;
  }
}

FunctionFactory.Instance.register("renderComfortQuote", renderComfortQuote);

function renderComfortQuoteIcon(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch(params[0] as ComfortLevel) {
    case ComfortLevel.Never:
    case ComfortLevel.Learning:
    case ComfortLevel.Reguarly:
      return `🙌`;
    case ComfortLevel.CantDo:
      return `🔀`;
  }
}

FunctionFactory.Instance.register("renderComfortQuoteIcon", renderComfortQuoteIcon);

function renderComfortQuoteTitle(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch(params[0] as ComfortLevel) {
    case ComfortLevel.Never:
      return `You’re in the right place!`;
    case ComfortLevel.Learning:
    case ComfortLevel.Reguarly:
      return `Awesome!`;
    case ComfortLevel.CantDo:
      return `No problem at all.`;
  }
}

FunctionFactory.Instance.register("renderComfortQuoteTitle", renderComfortQuoteTitle);

const comfortSplashTitleExpression = {
  name: "comfortSplashTitle",
  expression: "renderComfortQuoteTitle({comfort})",
};

const comfortSplashIconExpression = {
  name: "comfortSplashIcon",
  expression: "renderComfortQuoteIcon({comfort})",
};

const comfortSplashElement = {
  name: 'comfort-splash',
  type: 'html',
  html: comfortSplashHtml,
}

const ComfortSplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A",
      fontSize: "12px",
    }}>
      🛠️ Building confidence 
    </div>
  )
}

export {
  comfortSplashElement,
  comfortSplashExpression,
  comfortSplashIconExpression,
  comfortSplashTitleExpression,
  ComfortSplashHeader,
}
